import { Box, Flex, Link, Stack, Text } from '@chakra-ui/react';
import { FiFacebook, FiInstagram, FiMail, FiPhone } from 'react-icons/fi';

const HomeContact = () => {
  return (
    <Box id="kontakt" as="section" py={16} px={6} bg="gray.50">
      <Stack gap={8} maxW="container.md" mx="auto" textAlign="center">
        <Text color="brand.orange.500" fontWeight="semibold" textTransform="uppercase" letterSpacing="wider">
          Kontakt
        </Text>
        <Box>
          <Flex wrap="wrap" justify="center" gap={6} textAlign="left">
            <Box flex="1 1 220px" maxW="260px">
              <Flex align="center" gap={3}>
                <Box color="orange.500" fontSize="xl" flexShrink={0}>
                  <FiPhone />
                </Box>
                <Box>
                  <Link href="tel:+48513018199" color="orange.600">+48 513 018 199</Link>
                </Box>
              </Flex>
            </Box>
            <Box flex="1 1 220px" maxW="260px">
              <Flex align="center" gap={3}>
                <Box color="orange.500" fontSize="xl" flexShrink={0}>
                  <FiMail />
                </Box>
                <Box>
                  <Link href="mailto:sekretariat@opanuj.to" color="orange.600">sekretariat@opanuj.to</Link>
                </Box>
              </Flex>
            </Box>
            <Box flex="1 1 220px" maxW="260px">
              <Flex align="center" gap={3}>
                <Box color="orange.500" fontSize="xl" flexShrink={0}>
                  <FiFacebook />
                </Box>
                <Box>
                  <Link href="http://www.facebook.com/opanuj.to" color="orange.600" target="_blank" rel="noreferrer">
                    facebook.com/opanuj.to
                  </Link>
                </Box>
              </Flex>
            </Box>
            <Box flex="1 1 220px" maxW="260px">
              <Flex align="center" gap={3}>
                <Box color="orange.500" fontSize="xl" flexShrink={0}>
                  <FiInstagram />
                </Box>
                <Box>
                  <Link href="https://www.instagram.com/opanuj.to/" color="orange.600" target="_blank" rel="noreferrer">
                    instagram.com/opanuj.to
                  </Link>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Stack>
    </Box>
  );
};

export default HomeContact;
